export default Object.freeze({
  DPT: /#{dpt}/g,
});
